import React from 'react';

import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';

export default function Text(props) {

    return (
        <Tooltip arrow title={props.message}>
            <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text" required={props.isRequired}>
                    {props.inputName}
        </InputLabel>
                <TextField
                    style={{ marginTop: 5, fontSize: 16, height: 30 }}
                    aria-label="minimum height"
                    rows={1}
                    fullWidth={true}
                    value={props.value}
                    helperText={props.helperText}
                    className='textArea-field'
                    onChange={(event) => props.handleChange(props.field, event.target.value)}
                    />
            </Grid>
        </Tooltip>
    )
}